import type { TokenResponse, User } from './types';

const KEY = 'familychat.session';

export interface StoredSession {
  accessToken: string;
  refreshToken: string;
  deviceId: string;
  user: User;
}

export function loadSession(): StoredSession | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as StoredSession;
    return parsed.accessToken && parsed.refreshToken ? parsed : null;
  } catch {
    return null;
  }
}

export function saveSession(response: TokenResponse): StoredSession {
  const session: StoredSession = {
    accessToken: response.accessToken,
    refreshToken: response.refreshToken,
    deviceId: response.deviceId,
    user: response.user,
  };
  localStorage.setItem(KEY, JSON.stringify(session));
  return session;
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
}

/**
 * Идентификатор устройства переживает выход из аккаунта: иначе каждый вход
 * создавал бы новую запись устройства, и список сессий зарастал бы мусором.
 */
const DEVICE_KEY = 'familychat.deviceId';

export function rememberedDeviceId(): string | undefined {
  return localStorage.getItem(DEVICE_KEY) ?? undefined;
}

export function rememberDeviceId(deviceId: string): void {
  localStorage.setItem(DEVICE_KEY, deviceId);
}

/** Имя устройства для списка сессий: «Chrome на Windows». */
export function describeDevice(): string {
  const ua = navigator.userAgent;
  const browser = /Edg\//.test(ua) ? 'Edge'
    : /Chrome\//.test(ua) ? 'Chrome'
    : /Firefox\//.test(ua) ? 'Firefox'
    : /Safari\//.test(ua) ? 'Safari'
    : 'браузер';
  const os = /Windows/.test(ua) ? 'Windows'
    : /Android/.test(ua) ? 'Android'
    : /iPhone|iPad/.test(ua) ? 'iOS'
    : /Mac OS X/.test(ua) ? 'macOS'
    : /Linux/.test(ua) ? 'Linux'
    : 'неизвестной системе';
  return `${browser} на ${os}`;
}
